import { Button } from '@scaleaq/scaleui';

import { Icon } from '@/utils';

type AddButtonProps = {
  label: string;
  onAdd: () => void;
  render?: boolean;
};
export const AddButton = ({ label, onAdd, render = true }: AddButtonProps) => {
  if (!render) return;
  return (
    <Button
      color={'neutral'}
      headIcon={Icon.Plus}
      label={label}
      onClick={onAdd}
      variant={'outline'}
    />
  );
};
